/* eslint-disable */
/**
 * AUTO-GENERATED by scripts/set-release-version.cjs.
 * Do not edit by hand — run `node scripts/set-release-version.cjs <version>`.
 *
 * The download page reads this so the version it advertises can never
 * drift from what the desktop-release workflow actually published or
 * what the add-on repo tells the Supervisor to install.
 */
export const RELEASE_VERSION = '1.2.3';
